export enum Environment {
    RIO = 'rio',
    VW_QA = 'vw-qa',
    VW = 'vw',
}
